interface IMinerNameParser {
  readonly letter: string;
  readonly rack: string;
  readonly YX: [number, number];
  readonly sectionCoords: string;
}

export const parseMinerName = (name: string): IMinerNameParser => {
  if (!name) {
    return {
      letter: "0",
      rack: "0",
      YX: [0, 0],
      sectionCoords: "00",
    };
  }

  const allNumbers = /[a-zA-Z]/g;

  const letter = findLastLetter(name);

  const index = name.indexOf(letter) < 0 ? 0 : name.indexOf(letter);

  const rack = name.slice(0, index);
  const sectionCoords = name.slice(index).replace(allNumbers, "");

  const [Y, X]: [number, number] =
    sectionCoords.length > 2
      ? (sectionCoords.split("-").map((c) => +c) as [number, number])
      : [+sectionCoords[0], +sectionCoords[1]];

  // console.log(
  //   "name = ",
  //   name,
  //   "before = ",
  //   rack,
  //   "letter = ",
  //   letter,
  //   "after = ",
  //   [Y, X]
  // );

  return {
    letter,
    rack,
    YX: [Y, X],
    sectionCoords,
  };
};

export const findLastLetter = (str: string) => {
  if (!str) {
    console.error("str = undefined");
    return "";
  }
  const lettersRegex = /[^A-Za-z]/g;
  const allLetters = str.replace(lettersRegex, "");
  const letter =
    allLetters.length > 1 ? allLetters[allLetters.length - 1] : allLetters;

  return letter;
};

export const makeMinerName = (name: string) => {
  const { sectionCoords, letter } = parseMinerName(name);
  if (!sectionCoords) {
    return name;
  }
  return `${letter}${sectionCoords}`;
};
